export const KLAVIYOEVENTS = {
    ActiveOnSite: "Active on Site",
    ProductViewed: "Product Viewed",
    ProductAddedToCart: "Product Added to Cart",
    NewSignUp : "New Sign Up",
    StartedRegistration: "Started Registration",
    SignUpStep2: "Sign Up - Step 2",
    SignUpStep3: "Sign Up - Step 3",
    SignUpStep4: "Sign Up - Step 4",
    SignUpStep5: "Sign Up - Step 5",
    RegistrationCompleted: "Payment Details Added"
}
